const NAMESPACE = 'REAL_DEVICE_GPS_LOCATION' as const;

const GPS_LOCATION_MODAL_IDENTIFIER = `${NAMESPACE}/gpsLocationModal` as const;

export default {
  GPS_LOCATION_MODAL_IDENTIFIER,
  NAMESPACE,
};
